import { DELETE_CARTRULE_REQUESTED } from './../edit/edit.actions';
import { FETCH_CARTRULES_REQUESTED, SORT_CARTRULES_REQUESTED } from './list.actions';
import { Component, OnInit, OnDestroy } from '@angular/core';
import store from './../../../store/store.module';
import * as _ from 'lodash';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import Redirect from "../../../models/Redirect";
import {UtilityService} from "../../../common/services/utility/utility.service";

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnDestroy {
  protected navigationSubscription: any;
  protected router: any;
  public store = store;
  public utilityService;

  constructor(private notification: NotificationService, private activeRouter: ActivatedRoute, router: Router, utilityService: UtilityService) {
    this.utilityService = utilityService;
    this.activeRouter = activeRouter;
    this.router = router;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        store.dispatch({ type: FETCH_CARTRULES_REQUESTED, data: this.getQuery() });
      }
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }

  public getQuery(): object {
    let supportedParams = ['sort', 'constraints', 'page', 'per_page', 'search', 'skus'];
    let queryParams = { page: 1 };
    if (_.keys(this.activeRouter.snapshot.queryParams).length > 0) {
      queryParams = _.assign(queryParams, this.activeRouter.snapshot.queryParams);
    }
    if (!queryParams['sort']) {
      queryParams['sort'] = '-id';
    }
    return _.pick(queryParams, supportedParams);
  }

  deleteItem(id) {
    if (confirm('Do you want to delete this cartrule?')) {
      store.dispatch({ type: DELETE_CARTRULE_REQUESTED, data: id });
    }
  }

  gotoCoupon(id) {
    this.utilityService.nextPageWithReferer(['/coupon/edit/' + id ], new Redirect(this.router.url, {}));
  }
}
